import { createContext, ReactNode } from 'react';

export const GroupContext = createContext<{
  isDirty?: boolean;
  label?: ReactNode;
  uuid: string;
  onClear: () => void;
}>({} as any);

export const PreExpandedContext = createContext<{
  preExpanded: string[];
  setPreExpanded: React.Dispatch<React.SetStateAction<string[]>>;
}>({} as any);
